import css from 'styled-jsx/css'
import Head from 'next/head'
import HeroSection from '../../containers/dealers/hero-section'
import DealerSignUpForm from '../../containers/dealers/sign-up-form'
import { useCallback, useState } from 'react'
import { useMutation, useQuery } from '@tanstack/react-query'
import { requestDealerAccess } from '../../api-client/account'
import { getStates, getStatesKey } from '../../api-client/account'
import ConfirmationModal from '../../containers/dealers/modals/confirmation-modal'
import Router from 'next/router'
import { ROUTES } from '../../constants'

// ----------------------------------------------------------------------

const styles = css`
  .container {
    max-width: 78.2rem;
    width: 100%;
    padding: 0 4rem;
    margin: 5.7rem auto 0;

    .content {
      .subTitle {
        display: block;
        text-align: center;
        color: var(--primary-text-color);
        font-size: 2.2rem;
      }
    }
  }

  @media (max-width: 1024px) {
    .container {
      max-width: 100%;
      margin-top: 2rem;
      padding: 0 1.1rem;

      .content {
        .subTitle {
          margin-top: 2rem;
          font-size: 1.2rem;
        }
      }
    }
  }
`

// ----------------------------------------------------------------------

const useDealersViewModel = () => {
  // Confirmation Modal
  const [isOpen, setIsOpen] = useState(false)

  const handleModalClose = useCallback(() => {
    setIsOpen(false)
    Router.push(ROUTES.Home)
  }, [])

  // Form
  const { data: { states } = {}, isLoading: statesFetching } = useQuery({
    queryKey: [getStatesKey],
    queryFn: getStates,
  })

  const {
    mutate: requestDealerAccessMutation,
    isLoading,
    error: requestDealerAccessError,
  } = useMutation({
    mutationFn: requestDealerAccess,
    onSuccess: () => setIsOpen(true),
  })

  const handleSubmit = useCallback(
    (data) => {
      requestDealerAccessMutation(data)
    },
    [requestDealerAccessMutation],
  )

  const modal = {
    isOpen,
    handleClose: handleModalClose,
  }

  const form = {
    states,
    statesFetching,
    isLoading,
    serverErrors: !!requestDealerAccessError?.error
      ? [requestDealerAccessError.error]
      : requestDealerAccessError?.errors,
    handleSubmit,
  }

  return {
    form,
    modal,
  }
}

// ----------------------------------------------------------------------

const Dealers = () => {
  const { form, modal } = useDealersViewModel()

  return (
    <>
      <Head>
        <title>privauto | Dealer Sign Up</title>
      </Head>

      {modal.isOpen && <ConfirmationModal onClose={modal.handleClose} />}

      <HeroSection />

      <div className='container'>
        <main className='content'>
          <span className='subTitle'>
            Complete the form below with your dealership details, and a privauto associate will
            be in touch with you shortly to complete the sign up process!
          </span>

          <DealerSignUpForm {...form} />
        </main>
      </div>

      <style jsx>{styles}</style>
    </>
  )
}

Dealers.getInitialProps = () => ({
  namespacesRequired: ['common'],
})

export default Dealers
